var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "follow-page" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "qr-panel" }, [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.qrcodeUrl,
            expression: "qrcodeUrl"
          }
        ],
        staticClass: "qr",
        attrs: { src: _vm.qrcodeUrl || "./static/images/follow-qr.png" },
        on: { load: _vm.handleQrcodeLoaded, error: _vm.handleQrcodeLoaded }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("长按关注公众号")])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "hero" }, [
      _c("img", {
        attrs: {
          src: require("./static/images/follow-hero.png"),
          alt: "科技主视觉"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b84b12a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b84b12a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/follow.vue
// module id = null
// module chunks = 